import styled from 'styled-components/macro';
import Form from '~/components/Form';
import GridCell from '~/components/GridCell';

export const EditPasswordForm = styled(Form)`
  border: none;
`;

export const SubmitGridCell = styled(GridCell)`
  margin-top: 34px;
`;
